import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=cd5f558e&scoped=true"
import script from "./NotificationBell.vue?vue&type=script&lang=ts"
export * from "./NotificationBell.vue?vue&type=script&lang=ts"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=cd5f558e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5f558e",
  null
  
)

export default component.exports